import { useState } from "react";

import Flex from "../../../components/Flex/Flex";

import styles from "./CreateNewBoxButton.module.css";
import { FbaBox, FbaShipment, useShipmentContext } from "@/contexts/ShipmentContext";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { handleCreateBox } from "@/api/fulfillment";
import InputNumber from "../../../components/forms/InputNumber/InputNumber";
import Button from "../../../components/forms/Button/Button";
import { useErrorModalContext } from "@/contexts/ErrorModalContext";
import { TransportType } from "@boxem/core-api-schema";

export type CreateNewBoxButtonProps = {
  createBoxes: (n: number) => Promise<void>;
};

export function CreateNewBoxButton(props: CreateNewBoxButtonProps) {
  const [ numberOfBoxesToCreate, setNumberOfBoxesToCreate ] = useState<number>(1);
  return (
    <div className={styles.createNewBoxButtonContainer}>
      <Flex align="center" gap={2}>
        <Button
          type="secondary"
          disableWhileOnClick={true}
          onClick={() => props.createBoxes(numberOfBoxesToCreate)}
        >
          Create new box{numberOfBoxesToCreate > 1 && "es"}:
        </Button>
        <InputNumber
          style={{width:"10rem"}}
          min={1}
          max={50}
          value={numberOfBoxesToCreate}
          onChange={value => setNumberOfBoxesToCreate(value)}
        />
      </Flex>
    </div>
  );
}
